'use client';

import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FC } from 'react';
import { Icon, IconButton } from '@/components/ui';
import { FilterOption } from '@/types/product-filter';

type SelectedFilterChipProps = {
  filterName: string;
  selectedFilter: FilterOption;
  onRemove: () => void;
};

const SelectedFilterChip: FC<SelectedFilterChipProps> = ({
  filterName,
  selectedFilter,
  onRemove,
}) => {
  return (
    <div
      className="mb-2 flex h-10 items-center justify-between rounded-full border bg-white pr-2 pl-3"
      data-testid="selected-filter-chip__container"
    >
      <span className="text-small" data-testid="selected-filter-chip__label">
        {filterName}: {selectedFilter.value}
      </span>
      <IconButton
        aria-label="Remove filter"
        variant="light"
        onClick={onRemove}
        data-testid="selected-filter-chip__remove-button"
      >
        <Icon icon={faTimes} />
      </IconButton>
    </div>
  );
};

export default SelectedFilterChip;
